import { Col, Form, Input, Row } from 'antd';
import Tomador from './Tomador';
import Fornecedor from './Fornecedor';
import TipoVolume from './TipoVolume';
import CidadeOrigem from './CidadeOrigem';
import { CustomizedFormProps } from './props';
import { SetStateAction } from 'react';
import { SelectTomador } from '../../../SelectTomador';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { converterBRLToFloat, formatarPeso, formatarValorBRL } from '../../../../utils/mask';
import { ROLE } from 'utils/roles';
import { TextLabel } from 'components/TextLabel';

const CustomizedForm: React.FC<CustomizedFormProps> = ({
  onChange,
  fields,
  setFields,
  setChaveNfe,
  setCodTomador,
  setValor,
  setNumNota,
  setPesoBruto,
  setCodCidadeOrigem,
  setObservacao,
  setCodFornecedor,
  setTipoVolume,
  setQtdVolume,
  nometomador,
  setNomeTomador,
  setNomeCidadeOrigem,
  setNomeFornecedor,
}) => {
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);
  const [form] = Form.useForm();

  return (
    <Form
      form={form}
      name="global_state"
      layout="vertical"
      fields={fields}
      onFieldsChange={(_, allFields) => {
        onChange(allFields);
      }}
    >
      <Row gutter={24}>
        <Col md={24} sm={24} xs={24}>
          <Form.Item name="chaveNfe" label={<TextLabel>Chave da NF</TextLabel>}>
            <Input onChange={(e: any) => setChaveNfe(e.target.value)} type="number" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col md={12} sm={24} xs={24}>
          {perfil !== ROLE.TRANSPORTADORA ? (
            <Tomador
              setCodTomador={function (value: SetStateAction<any>): void {
                setCodTomador(value);
              }}
              setNomeTomador={function (value: SetStateAction<string>): void {
                setNomeTomador?.(value);
              }}
            />
          ) : (
            <Form.Item
              name="nometomador"
              label={<TextLabel>Tomador</TextLabel>}
              rules={[{ required: true, message: 'Por favor preencha este campo!' }]}
            >
              <SelectTomador
                setSelectedTomadorOrdemCarga={setCodTomador}
                nometomadorXml={nometomador}
                setNomeTomadorXML={setNomeTomador as React.Dispatch<SetStateAction<string>>}
              />
            </Form.Item>
          )}
        </Col>

        <Col md={12} sm={24} xs={24}>
          <Fornecedor
            setCodFornecedor={function (value: SetStateAction<any>): void {
              setCodFornecedor(value);
            }}
            setNomeFornecedor={function (value: SetStateAction<string>): void {
              setNomeFornecedor?.(value as string);
            }}
          />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col md={8} sm={24} xs={24}>
          <TipoVolume setTipoVolume={setTipoVolume as React.Dispatch<SetStateAction<string>>} />
        </Col>

        <Col md={8} sm={24} xs={12}>
          <Form.Item
            name="qtdVolume"
            label={<TextLabel>Quantidade</TextLabel>}
            rules={[{ required: true, message: 'Por favor preencha este campo!' }]}
          >
            <Input
              onChange={(e: any) => {
                setQtdVolume(e.target.value);
              }}
            />
          </Form.Item>
        </Col>

        <Col md={8} sm={24} xs={12}>
          <Form.Item
            name="numNota"
            label={<TextLabel>Nº da nota</TextLabel>}
            rules={[{ required: true, message: 'Por favor preencha este campo!' }]}
          >
            <Input onChange={(e: any) => setNumNota(e.target.value)} type="number" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col md={8} sm={24} xs={12}>
          <Form.Item
            name="pesoBruto"
            label={<TextLabel>Peso bruto</TextLabel>}
            rules={[{ required: true, message: 'Por favor preencha este campo!' }]}
          >
            <Input
              suffix="KG"
              onChange={(e: any) => {
                const valueformated = formatarPeso(e.target.value);
                setFields([...fields, { name: ['pesoBruto'], value: valueformated }]);
              }}
              onBlur={(e: any) => {
                const value = converterBRLToFloat(e.target.value);
                setPesoBruto(value.toString());
              }}
            />
          </Form.Item>
        </Col>

        <Col md={8} sm={24} xs={12}>
          <Form.Item
            name="valor"
            label={<TextLabel>Valor</TextLabel>}
            rules={[{ required: true, message: 'Por favor preencha este campo!' }]}
          >
            <Input
              // prefix="R$"

              type="text"
              onChange={(e: any) => {
                const valueformated = formatarValorBRL(e.target.value);
                setFields([...fields, { name: ['valor'], value: valueformated }]);
                form.setFieldsValue({
                  valor: formatarValorBRL(e.target.value),
                });
              }}
              onBlur={(e: any) => {
                const value = converterBRLToFloat(e.target.value);
                setValor(value.toString());
              }}
            />
          </Form.Item>
        </Col>

        <Col md={8} sm={24} xs={24}>
          <CidadeOrigem
            setCodCidadeOrigem={setCodCidadeOrigem as React.Dispatch<SetStateAction<any>>}
            setNomeCidadeOrigem={setNomeCidadeOrigem}
          />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col md={24} sm={24} xs={24}>
          <Form.Item name="observacao" label={<TextLabel>Observação</TextLabel>}>
            <Input.TextArea rows={10} onChange={(e: any) => setObservacao(e.target.value)} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default CustomizedForm;
